import { apuracaoFilterConfig } from "./apuracao-filter-config";
import DateUtils from "../../../shared/utils/DateUtils";

export const apuracaoHistoryFilterConfig = [
	{
		section: "Período",
		fields: [
			{
				name: "period",
				label: "",
				type: "rangeBetween",
				inputType: "text",
				separator: "→",
				fromPlaceholder: "01/2026",
				toPlaceholder: "07/2026",
				defaultValue: {
					from: "",
					to: ""
				},
				maxLength: 7,
				onChange: DateUtils.formatMonthYear,
				columns: 12
			}
		]
	},
	{
		section: "Status da apuração",
		fields: [
			{
				name: "status",
				label: "",
				type: "select",
				placeholder: "Todos",
				defaultValue: "",
				options: [
					{
						label: "Aprovado",
						value: "APROVADO"
					},
					{
						label: "Reprovado",
						value: "REPROVADO"
					}
				],
				columns: 12
			}
		]
	},
	...apuracaoFilterConfig
];